export { default } from "bullitttime-embercomponents/components/class-group-results-card";
